import * as React from "react";
import classnames from "classnames";

const styles = require("./styles.module.scss");

interface DoubleClickToActivateProps {
  /**
   * leanRight: to be used if the editable content goes off the left edge of the screen.
   * Unsets the css `right` property
   */
  leanRight?: boolean;
  children: { initial: React.ReactNode; activated: React.ReactNode };
  active?: boolean;
  setActive: Function;
}

const DoubleClickToActivate: React.FunctionComponent<DoubleClickToActivateProps> = ({
  leanRight = false,
  active = false,
  setActive,
  children: { initial, activated },
}) => (
  <div className={styles.container}>
    <div
      className={styles.initialField}
      onDoubleClick={() => {
        setActive(true);
      }}
    >
      {initial}
    </div>
    {active && (
      <div>
        <div
          className={styles.backdrop}
          onClick={() => {
            setActive(false);
          }}
        />
        <div className={classnames(styles.activeField, leanRight && styles.leanRight)}>
          {activated}
        </div>
      </div>
    )}
  </div>
);

export default DoubleClickToActivate;
